// project-imports
import { deleteRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - FILES ||============================== //

export async function handleFiles(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/files', action.data);
    case 'update':
      return putRequest(`/files/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/files/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleFiles] - Unknown method');
      break;
  }
}
